import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function AccordionItem({
  question,
  answer,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border-b border-charcoal/10 last:border-0" data-id="element-180">
      <button className="w-full py-6 flex justify-between items-center text-left focus:outline-none group" onClick={onClick} data-id="element-181">
        <span className="font-serif text-xl pr-8 group-hover:text-terracotta transition-colors" data-id="element-182">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="text-terracotta flex-shrink-0" data-id="element-183">
          <ChevronDown size={24} data-id="element-184" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-185">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-186">
            <div className="pb-6 text-charcoal/80 leading-relaxed pr-8" data-id="element-187">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
interface AccordionProps {
  items: {
    question: string;
    answer: string;
  }[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="w-full max-w-3xl mx-auto bg-white/50 backdrop-blur-sm rounded-2xl p-6 md:p-8 shadow-sm border border-charcoal/5" data-id="element-188">
      {items.map((item, index) => <AccordionItem key={index} question={item.question} answer={item.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-189" />)}
    </div>;
}